//#region src/ScreeningModality/constants.ts
/**
* SYNCED ENUM: Values in frontend and backend versions of ScreeningModality must be synced!
*
* Any changes here should reflect valid options in the backend enum at:
* monoweb.django_apps.preventive_care.protocols.types.ScreeningModality
*/
var ScreeningModality = /* @__PURE__ */ function(ScreeningModality) {
	ScreeningModality["BREAST_MRI"] = "breast_mri";
	ScreeningModality["CARDIO_PANEL"] = "cardio_panel";
	ScreeningModality["CLINICAL_BREAST_EXAM"] = "clinical_breast_exam";
	ScreeningModality["COLOGUARD"] = "cologuard";
	ScreeningModality["COLONOSCOPY"] = "colonoscopy";
	ScreeningModality["GENETICS_TESTING"] = "genetics_testing";
	ScreeningModality["FIT_TEST"] = "fit_test";
	ScreeningModality["HPV_TEST"] = "hpv_test";
	ScreeningModality["LUNG_CT"] = "lung_ct";
	ScreeningModality["MAMMOGRAM"] = "mammogram";
	ScreeningModality["PAP_SMEAR"] = "pap_smear";
	ScreeningModality["PARTIAL_COLONOSCOPY"] = "partial_colonoscopy";
	ScreeningModality["PSA_TEST"] = "psa_test";
	ScreeningModality["SKIN_DERM_EXAM"] = "skin_derm_exam";
	ScreeningModality["VIRTUAL_COLONOSCOPY"] = "virtual_colonoscopy";
	return ScreeningModality;
}({});
//#endregion
export { ScreeningModality as t };

//# sourceMappingURL=ScreeningModality-ClqhAEZw.js.map